/* Descripciones de la guía de programación (EPG). Muchos proveedores pegan al principio los datos del programa en una sola
   línea: «Entretenimiento,Magacín | 2026 | +16 | *5.4/10 · Programa de actualidad…». Aquí se separan para poder enseñar
   el año, la valoración, la edad y el género como en las fichas, y dejar solo la sinopsis como texto. Módulo puro. */

const YEAR = /^(?:19|20)\d{2}$/;
const AGE = /^(?:TP|\+\d{1,2}|\d{1,2}\+)$/i;
const RATING = /^(?:\*\s*(\d{1,2}(?:[.,]\d+)?)(?:\s*\/\s*10)?|(\d{1,2}(?:[.,]\d+)?)\s*\/\s*10)$/;

/**
 * Devuelve { plot, genres, year, age, rating, hasMeta }. Si el texto no empieza con ese bloque de datos (necesita barras «|» y
 * al menos un año, una edad o una valoración reconocibles antes del primer « · »), se devuelve entero como sinopsis.
 */
export function splitProgramDesc(desc) {
    const text = String(desc == null ? '' : desc).trim();
    const plain = { plot: text, genres: [], year: '', age: '', rating: 0, hasMeta: false };
    if (!text) return plain;
    const starred = parseStarred(text);
    if (starred) return starred;
    const m = /^([^·\n]*\|[^·\n]*?)\s*·\s*([\s\S]*)$/.exec(text) || /^([^·\n]*\|[^·\n]*)$/.exec(text);
    if (!m) return plain;
    const out = { plot: (m[2] || '').trim(), genres: [], year: '', age: '', rating: 0, hasMeta: false };
    const rest = [];
    String(m[1]).split('|').map((x) => x.trim()).filter(Boolean).forEach((field) => {
        let r;
        if (!out.year && YEAR.test(field)) out.year = field;
        else if (!out.age && AGE.test(field)) out.age = field.toUpperCase().replace(/^(\d{1,2})\+$/, '+$1');
        else if (!out.rating && (r = RATING.exec(field))) out.rating = Number(String(r[1] || r[2]).replace(',', '.'));
        else rest.push(field);
    });
    if (!out.year && !out.age && !out.rating) return plain;
    out.genres = rest.join(',').split(/[,/]/).map((x) => x.trim()).filter(Boolean).slice(0, 3);
    out.hasMeta = true;
    return out;
}

/** Otra forma frecuente: «· Deportes ★6.2/10 (España) +TP · Sinopsis: Texto… Votos: 307.» (género, estrellas, país entre paréntesis y edad,
    seguidos de la sinopsis con su etiqueta y, al final, el número de votos). Solo aquí aparecen `country` y `votes`. */
function parseStarred(text) {
    const m = /^\s*·?\s*([^★·|]*?)\s*★\s*(\d{1,2}(?:[.,]\d+)?)\s*(?:\/\s*10)?\s*(?:\(([^)]*)\))?\s*(\+?[A-Za-z0-9]{1,3}\+?)?\s*(?:·\s*([\s\S]*))?$/.exec(text);
    if (!m) return null;
    let age = '';
    if (m[4]) { const a = m[4]; if (/^\+?TP$/i.test(a)) age = 'TP'; else if (/^\+\d{1,2}$/.test(a)) age = a; else if (/^\d{1,2}\+$/.test(a)) age = '+' + a.slice(0, -1); else return null; }
    let plot = (m[5] || '').trim().replace(/^Sinopsis:\s*/i, '');
    let votes = 0;
    const v = /\s*Votos:\s*([\d.,]+?)\.?\s*$/i.exec(plot);
    if (v) { votes = Number(v[1].replace(/[.,]/g, '')) || 0; plot = plot.slice(0, v.index).trim(); }
    const genres = m[1].split(/[,/]/).map((x) => x.trim()).filter(Boolean).slice(0, 3);
    const out = { plot, genres, year: '', age, rating: Number(m[2].replace(',', '.')), hasMeta: true };
    if (m[3]) out.country = m[3].trim();
    if (votes) out.votes = votes;
    return out;
}

/** Datos del programa en una línea de texto («2026 · +16 · ★ 5,4 · Entretenimiento, Magacín»), para sitios sin etiquetas. */
export function programMetaText(p) {
    if (!p || !p.hasMeta) return '';
    const parts = [];
    if (p.year) parts.push(p.year);
    if (p.age) parts.push(p.age);
    if (p.rating) parts.push('★ ' + String(Math.round(p.rating * 10) / 10).replace('.', ','));
    if (p.genres.length) parts.push(p.genres.slice(0, 2).join(', '));
    return parts.join(' · ');
}
